<template>
  <div>
    <div class="Kanit" style="color: black">
      <div class="text-center Kanit" style="font-size: 25px; font-weight: 600">
        ประวัติแจ้งอัพเดทงาน
      </div>
      <v-container>
        <div v-if="data.history_update_job && data.history_update_job.length">
          <v-card
            class="mb-2"
            v-for="job in data.history_update_job"
            :key="job.orderid"
          >
            <v-card-text>
              <div style="color: red; font-size: 11px; font-weight: bold">
                {{ moment(job.time_to_send).format("DD-MM-YYYY / HH:mm") }}
              </div>
              <div style="color: black">
                <span style="color: rgb(45 144 229); font-weight: 600">
                  ผู้จ้าง : </span
                >{{ data.customer_name }}
              </div>
              <div style="color: black">
                <span style="color: rgb(45 144 229); font-weight: 600"
                  >ข้อความที่ส่ง : </span
                >{{ job.message }}
              </div>

              <v-row dense>
                <v-col
                  v-for="(img, k) in job.images"
                  :key="img + '__' + k"
                  cols="2"
                >
                  <v-img
                    @click="
                      showimg = img;
                      showimgdialog = true;
                    "
                    aspect-ratio="1.3"
                    class="grey darken-2"
                    :src="img"
                    :lazy-src="img"
                  ></v-img>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </div>
        <div v-else>
          <Nojob></Nojob>
        </div>
        <v-dialog v-model="showimgdialog">
          <div v-if="showimgdialog">
            <v-img
              @click="
                showimgdialog = false;
                showimg = '';
              "
              class="grey darken-2"
              :src="showimg"
              :lazy-src="showimg"
            ></v-img>
          </div>
        </v-dialog>
      </v-container>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import Nojob from "./Nojob.vue";
export default {
  components: {
    Nojob,
  },
  props: ["data"],
  data() {
    return {
      showimg: "",
      showimgdialog: false,
    };
  },
  computed: {
    moment() {
      return moment;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>